<template>
	<div style="display: flex; justify-content: center;">
		<form ref="form" method="GET" :action="'/web-search/results/' + this.locale">
			<el-select-v2 v-model="value" :options="options" :placeholder="$trans('web_search.filters.please_select')" style="width: 500px" filterable multiple :multiple-limit="3" />
			<el-button :type="type" style="margin-left: 15px;" :disabled="disabled" @click="submit">
				{{ $trans('web_search.filters.search') }}
			</el-button>
			<input type="hidden" name="competence" :value="selectedCompetencesIds.join('-')">
			<input type="hidden" name="job_tag" :value="selectedJobTagsIds.join('-')">
		</form>
	</div>
</template>

<script>
export default {
	props: {
		competences: Array,
		jobTags: Array,
	},
	data() {
		return {
			type: 'info',
			disabled: true,
			value: [],
		}
	},
	computed: {
		locale() {
			return window.locale;
		},
		options() {
			let jobTags = Object.entries(this.jobTags).map(([idx, jobTag]) => ({
				value: 'jobtag_' + jobTag.id,
				label: jobTag.name,
			})).filter((jobTag) => jobTag.label);

			let competences = Object.entries(this.competences).map(([idx, competence]) => ({
				value: 'competence_' + competence.id,
				label: competence.name,
			})).filter((competence) => competence.label);

			return jobTags.concat(competences).sort((a, b) => {
				let index = 'label';
				if (a[index] < b[index])
					return -1;
				if (a[index] > b[index])
					return 1;
				return 0;
			});
		},
		selectedCompetencesIds() {
			return this.value.map((item) => item.split('_')).filter(item => (item[0] == 'competence')).map(item => item[1]);
		},
		selectedJobTagsIds() {
			return this.value.map((item) => item.split('_')).filter(item => (item[0] == 'jobtag')).map(item => item[1]);
		},
	},
	watch: {
		value() {
			this.type = this.value.length ? 'primary' : 'info';
			this.disabled = !this.value.length;
		}
	},
	methods: {
		submit() {
			this.$refs.form.submit()
		}
	}
}
</script>

<style>
.el-button--primary {
	--el-button-text-color: var(--el-color-white);
	--el-button-bg-color: #41ABC4;
	--el-button-border-color: #41ABC4;
	--el-button-outline-color: var(--el-color-primary-light-5);
	--el-button-active-color: var(--el-color-primary-dark-2);
	--el-button-hover-text-color: var(--el-color-white);
	--el-button-hover-link-text-color: var(--el-color-primary-light-5);
	--el-button-hover-bg-color: #2699b2;
	--el-button-hover-border-color: #2699b2;
	--el-button-active-bg-color: var(--el-color-primary-dark-2);
	--el-button-active-border-color: var(--el-color-primary-dark-2);
	--el-button-disabled-text-color: var(--el-color-white);
	--el-button-disabled-bg-color: var(--el-color-primary-light-5);
	--el-button-disabled-border-color: var(--el-color-primary-light-5);
}
</style>
